import { render, staticRenderFns } from "./DocentHistoryList.vue?vue&type=template&id=1951373e&scoped=true"
import script from "./DocentHistoryList.vue?vue&type=script&lang=js"
export * from "./DocentHistoryList.vue?vue&type=script&lang=js"
import style0 from "./DocentHistoryList.vue?vue&type=style&index=0&id=1951373e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1951373e",
  null
  
)

export default component.exports